import React from 'react';

export default function SectionHeading({
  badge,
  title,
  subtitle,
  align = 'left',
  dark = false,
  className = '',
  titleClassName = '',
}) {
  const isCenter = align === 'center';

  return (
    <div className={`max-w-3xl ${isCenter ? 'mx-auto text-center' : 'text-left'} ${className}`}>
      {badge && (
        <div className="inline-flex items-center gap-2 mb-3">
          <span className={`h-1.5 w-1.5 rounded-full ${dark ? 'bg-[#2A9D8F]' : 'bg-[#0F766E]'}`}></span>
          <span
            className={`text-xs font-semibold uppercase tracking-widest-editorial ${
              dark ? 'text-[#2A9D8F]' : 'text-[#0F766E]'
            }`}
          >
            {badge}
          </span>
        </div>
      )}
      <h2
        className={`font-serif text-3xl sm:text-4xl lg:text-4xl leading-[1.18] font-normal tracking-tight ${
          dark ? 'text-white' : 'text-[#123B5D]'
        } ${titleClassName}`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-4 text-base sm:text-lg leading-relaxed ${
            dark ? 'text-[#D9E8E5]' : 'text-[#64748B]'
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
